import React, { useContext, useState } from 'react';

import { Context } from 'store';
import { Card, Button, Modal } from 'antd';

import services from '_src/services';
import { PageContainer } from '_src/shared/styles';
import { Refresh, AsyncTable, AsyncModal } from '_src/components';
import { ModalHeader, ModalSection, WarningText, ClientName, ClientKey } from './styles';

export default () => {
  const { setShown } = useContext(Context);

  const config = services['integrationClients'];
  const resource = 'integrationClients';

  const [initialValues, setInitialValues] = useState({});
  const [credentials, setCredentials] = useState(null);

  const onRowClick = ({ allowedStudentFilters, ...record }) => {
    setInitialValues({
      ...record,
      allowedStudentFilters: Object.keys(allowedStudentFilters).filter(
        studetFilter => allowedStudentFilters[studetFilter]
      )
    });
    setShown(resource);
  };

  const onModalClose = () => {
    setShown(resource, false);
    setInitialValues({});
  };

  const onSuccess = response => {
    const clientData = response?.client?.data || response?.data;
    const clientKey = clientData?.client_key || clientData?.clientKey;
    const clientSecret = clientData?.client_secret || clientData?.clientSecret;

    if (clientKey && clientSecret && !initialValues?.id) {
      setCredentials({
        clientKey: clientKey,
        clientSecret: clientSecret,
        name: clientData.name
      });
    }
  };

  const closeCredentialsModal = () => {
    setCredentials(null);
  };

  return (
    <PageContainer>
      <Refresh />
      <Card title="Integrations">
        <Button
          type="primary"
          onClick={() => {
            setInitialValues({ rateLimit: 100, isActive: true });
            setShown(resource);
          }}
        >
          Create Client
        </Button>
        <AsyncTable
          resource={resource}
          config={{
            ...config,
            table: config.table
          }}
          fileName={resource}
          onRowClick={onRowClick}
          rowClassName={record => (!record.isActive ? 'row-inactive' : '')}
        />
        <AsyncModal
          showDelete={true}
          saveText="Submit"
          title={initialValues?.id ? 'Edit Client' : 'Create Client'}
          resource={resource}
          closeModal={onModalClose}
          initialValues={initialValues}
          onSuccess={onSuccess}
        ></AsyncModal>
        <Modal
          title="API Credentials Created"
          visible={!!credentials}
          onCancel={closeCredentialsModal}
          footer={[
            <Button key="close" type="primary" onClick={closeCredentialsModal}>
              I have saved these credentials
            </Button>
          ]}
          closable={false}
          maskClosable={false}
        >
          <ModalHeader>
            <WarningText>
              WARNING: Save these credentials now. They cannot be retrieved later.
            </WarningText>
          </ModalHeader>

          <ModalSection>
            <strong>Client Name:</strong>
            <ClientName>{credentials?.name}</ClientName>
          </ModalSection>

          <ModalSection>
            <strong>Client Key (X-API-Key):</strong>
            <ClientKey>{credentials?.clientKey}</ClientKey>
          </ModalSection>

          <ModalSection>
            <strong>Client Secret (X-API-Secret):</strong>
            <ClientKey>{credentials?.clientSecret}</ClientKey>
          </ModalSection>
        </Modal>
      </Card>
    </PageContainer>
  );
};
